import React from 'react'
import PlatformSvg from 'core-system/Icons/PlatformSvg'
import FormattingUtils from 'shared/FormattingUtils'
import styled from 'styled-components'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'

const Container = styled.div`
  margin-bottom: 1.5rem;
`

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`

const BudgetContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`

interface SummaryBudgetProps {
  title: string
  lines: {
    title: string
    value: number
  }[]
}

const SummaryBudget = React.memo((props: SummaryBudgetProps) => {
  const { title, lines } = props
  return (
    <>
      <Container>
        <HeaderContainer>
          <PlatformSvg folder='metrics' variant='money' />
          <Text variant='action3' marginLeft='0.5rem'>
            {title}
          </Text>
        </HeaderContainer>
        {lines.map((line) => (
          <>
            <Text
              variant='action3'
              marginBottom='0.75rem'
              textColor={palette.text.secondary}
              captionTitle
            >
              {line.title}
            </Text>
            <BudgetContainer>
              <Text variant='h4'>
                {FormattingUtils.formatDollar(line.value, 0)}
              </Text>
              <Text variant='action4' marginLeft='0.5rem'>
                per Commuter
              </Text>
            </BudgetContainer>
          </>
        ))}
      </Container>
    </>
  )
})
// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  SummaryBudget.displayName = 'SummaryBudget'
}

export default SummaryBudget
